<script lang="ts">
    export let column: BlockColumn<"text">
</script>

{@html column.text || ""}

<style lang="less">
    
</style>
